import React, { FC } from 'react'
import { Box, Typography, Paper } from '@mui/material'
import DashboardIcon from '@mui/icons-material/Dashboard'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'
import { PortalLayout } from '@/apps/legacy/components/portal/PortalLayout'

export const PortalHomePage: FC = () => {
  return (
    <>
      <PortalLayout>
        {/* ランディングページコンテンツ */}
        <Box
          sx={{
            minHeight: 'calc(100vh - 64px)',
            bgcolor: colorTokens.background.page,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Paper
            elevation={0}
            sx={{
              p: { xs: 4, sm: 6 },
              maxWidth: 800,
              width: '100%',
              textAlign: 'center',
              backgroundColor: colorTokens.background.paper,
              border: `1px solid ${colorTokens.border.light}`,
              borderRadius: 2,
            }}
          >
            <DashboardIcon
              sx={{
                fontSize: 80,
                color: colorTokens.grey[500],
                mb: 3,
              }}
            />
            <Typography
              variant="h5"
              component="h1"
              sx={{
                mb: 3,
                color: colorTokens.text.primary,
              }}
            >
              管理ポータル
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: colorTokens.text.secondary,
                lineHeight: 1.8,
              }}
            >
              左側のメニューから機能を選択してください
            </Typography>
          </Paper>
        </Box>
      </PortalLayout>
    </>
  )
}
